var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3-Copy",
    fill: "#808080",
    transform: "translate(11.500000, 12.000000) scale(-1, 1) translate(-11.500000, -12.000000) ",
    points: "19.1204449 23.3983664 19.1204449 5.67879077e-14 12.4338154 5.67879077e-14 3.84373749 5.67879077e-14 3.67795328 5.67879077e-14 3.67795328 23.3710194 0 23.3710194 0 24 6.71426029 24 18.5719626 23.9780493 18.5719626 0.628980562 18.4849388 0.628980562 18.4849388 24 23 24 23 23.3710194 19.1204449 23.3710194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99989054,11.500652 C6.00552906,11.7598808 5.79271022,11.9988087 5.50425088,12 C5.21116309,12.0011948 5.00137448,11.7676515 5,11.5008179 C4.99859997,11.226341 5.22898643,10.9985397 5.50385452,11 C5.77745682,11.0014617 5.99967318,11.2257285 5.99989054,11.500652",
    id: "Fill-15",
    fill: "#FFFFFF",
    transform: "translate(5.500000, 11.500000) scale(-1, 1) translate(-5.500000, -11.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedRoom);
export default __webpack_public_path__ + "static/media/closedRoom.49043ed249c634d7c24a945237415cea.svg";
export { ForwardRef as ReactComponent };